import { render, staticRenderFns } from "./physician-modal.vue?vue&type=template&id=52385eae"
import script from "./physician-modal.vue?vue&type=script&lang=js"
export * from "./physician-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports